var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "595.281px",
    height: "419.529px",
    viewBox: "0 0 595.281 419.529",
    enableBackground: "new 0 0 595.281 419.529",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "resize-vertical",
    fill: "#00AEEF",
    d: "M377.436,318.99l-73.364,93.52c-5.624,7.171-15.999,8.427-23.171,2.802 c-1.044-0.817-1.985-1.76-2.803-2.802l-73.363-93.52c-5.627-7.171-4.373-17.548,2.799-23.174c2.907-2.28,6.494-3.519,10.188-3.519 h32.097v-49.52c0-9.116,7.39-16.508,16.507-16.508h49.52c9.116,0,16.506,7.392,16.506,16.508v49.52h32.098 c9.117,0,16.506,7.39,16.506,16.506C380.955,312.498,379.715,316.085,377.436,318.99z M217.722,127.232h32.097v49.52 c0,9.115,7.39,16.506,16.507,16.506h49.52c9.116,0,16.506-7.391,16.506-16.506v-49.52h32.098c9.117,0,16.506-7.391,16.506-16.506 c0-3.694-1.239-7.281-3.519-10.187L304.072,7.02c-5.624-7.172-15.999-8.427-23.171-2.802c-1.044,0.817-1.985,1.758-2.803,2.802 l-73.363,93.519c-5.627,7.172-4.374,17.547,2.799,23.174C210.441,125.993,214.028,127.232,217.722,127.232z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.512448835db11c6db4df389286c9c44d.svg";
export { ForwardRef as ReactComponent };